import { Modal } from 'mobileApp/common/component/modal'
import styled from 'styled-components'

interface InsuranceClauseProps {
  label: string
  btnText: string
  modalId: string
  contentFn: React.ComponentType | (() => JSX.Element)
}

export const InsuranceClause = ({ label, btnText, modalId, contentFn }: InsuranceClauseProps) => {
  return (
    <>
      <section className="row mb-3">
        <div className="col-sm-4 text-primary">{label}</div>
        <div className="col-sm-8 text-muted fs_caption mt-3 mt-sm-0">
          <ClauseBtn type="button" className="btn" data-toggle="modal" data-target={`#${modalId}`}>
            {btnText}
          </ClauseBtn>
        </div>
      </section>

      <Modal id={modalId} title={btnText} contentFn={contentFn} />
    </>
  )
}

const ClauseBtn = styled.button`
  display: block;
  color: #6c757d;
  padding: 0px;
  margin-bottom: 1rem;
  text-decoration: underline;
  text-align: left;
`
